/* Favoriten: Herz-Schaltfläche auf der Produktkachel */
document.addEventListener("DOMContentLoaded", () => {
  const allFavoriteButtons = document.querySelectorAll(".favorite-button");
  allFavoriteButtons.forEach(button => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const willBeFavorite = !button.classList.contains("is-favorite");
      button.classList.toggle("is-favorite", willBeFavorite);
      button.setAttribute("data-favorite", willBeFavorite);
      const productId = button.getAttribute("data-product");
      const customerId = button.getAttribute("data-customer");
      await fetch("https://sereni-server-418706328134.europe-west1.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId, customerId, is: willBeFavorite })
      });
    });
  });
});

/* -------------------------------------------------------------------
   Wunsch-Lieferzeitfenster im Warenkorb
   Erster Klick setzt den Beginn, zweiter das Ende. Derselbe Tag zweimal
   ergibt einen einzelnen Tag. Wochenenden und bundesweite Feiertage sind
   gesperrt, fruehestens zwei Werktage ab heute.
   ------------------------------------------------------------------- */
(function () {
  var input = document.getElementById('CartDeliveryDateInput');
  if (!input) return;

  var calendarEl = document.getElementById('CartDeliveryCalendar');
  var vonEl = document.getElementById('CartDeliveryFrom');
  var bisEl = document.getElementById('CartDeliveryTo');
  var hinweisEl = document.getElementById('CartDeliveryHint');

  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }
  function addDays(date, n) { var d = new Date(date); d.setDate(d.getDate() + n); return d; }
  function dateKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function anzeige(d) {
    return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.' + d.getFullYear();
  }
  function germanHolidays(year) {
    var easter = easterSunday(year);
    return [
      new Date(year, 0, 1), addDays(easter, -2), addDays(easter, 1),
      new Date(year, 4, 1), addDays(easter, 39), addDays(easter, 50),
      new Date(year, 9, 3), new Date(year, 11, 25), new Date(year, 11, 26)
    ].map(dateKey);
  }
  function isHoliday(date) { return germanHolidays(date.getFullYear()).indexOf(dateKey(date)) !== -1; }
  function isWeekend(date) { var day = date.getDay(); return day === 0 || day === 6; }
  function isBusinessDay(date) { return !isWeekend(date) && !isHoliday(date); }
  function addBusinessDays(date, n) {
    var d = new Date(date), count = 0;
    while (count < n) { d = addDays(d, 1); if (isBusinessDay(d)) count++; }
    return d;
  }

  var today = new Date(); today.setHours(0, 0, 0, 0);
  var minDate = addBusinessDays(today, 2);
  var viewYear = minDate.getFullYear();
  var viewMonth = minDate.getMonth();
  var von = null, bis = null;

  var monthNames = ["Januar","Februar","M\u00e4rz","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  var dayNames = ["Mo","Di","Mi","Do","Fr","Sa","So"];

  function uebernehmen() {
    if (!von) {
      input.value = ''; vonEl.value = ''; bisEl.value = '';
      hinweisEl.textContent = '';
      return;
    }
    if (!bis || dateKey(von) === dateKey(bis)) {
      input.value = anzeige(von);
      vonEl.value = dateKey(von);
      bisEl.value = dateKey(von);
      hinweisEl.textContent = 'Einzelner Tag gew\u00e4hlt. F\u00fcr einen Zeitraum bitte einen zweiten Tag anklicken.';
    } else {
      input.value = anzeige(von) + ' bis ' + anzeige(bis);
      vonEl.value = dateKey(von);
      bisEl.value = dateKey(bis);
      var tage = Math.round((bis - von) / 86400000) + 1;
      hinweisEl.textContent = 'Zeitraum \u00fcber ' + tage + ' Kalendertage gew\u00e4hlt.';
    }
  }

  function render() {
    var firstOfMonth = new Date(viewYear, viewMonth, 1);
    var startWeekday = firstOfMonth.getDay();
    startWeekday = startWeekday === 0 ? 6 : startWeekday - 1;
    var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

    var html = '<div class="delivery-calendar__header">'
      + '<button type="button" data-action="prev" aria-label="Vorheriger Monat">&#8249;</button>'
      + '<span>' + monthNames[viewMonth] + ' ' + viewYear + '</span>'
      + '<button type="button" data-action="next" aria-label="N\u00e4chster Monat">&#8250;</button></div>'
      + '<div class="delivery-calendar__grid">';
    dayNames.forEach(function (d) { html += '<div class="delivery-calendar__daylabel">' + d + '</div>'; });
    for (var s = 0; s < startWeekday; s++) { html += '<div>&nbsp;</div>'; }
    for (var day = 1; day <= daysInMonth; day++) {
      var d = new Date(viewYear, viewMonth, day);
      var disabled = d < minDate || !isBusinessDay(d);
      var klassen = 'delivery-calendar__day';
      if (disabled) klassen += ' is-disabled';
      if (von && dateKey(d) === dateKey(von)) klassen += ' is-selected is-start';
      if (bis && dateKey(d) === dateKey(bis)) klassen += ' is-selected is-end';
      if (von && bis && d > von && d < bis) klassen += ' is-inrange';
      html += '<button type="button" class="' + klassen + '"'
        + (disabled ? ' disabled' : ' data-date="' + dateKey(d) + '"') + '>' + day + '</button>';
    }
    html += '</div><div class="delivery-calendar__fuss">'
      + '<span>' + (von && !bis ? 'Jetzt letzten Tag w\u00e4hlen' : 'Ersten Tag w\u00e4hlen') + '</span>'
      + '<button type="button" data-action="reset">Zur\u00fccksetzen</button>'
      + '<button type="button" data-action="close">Fertig</button></div>';
    calendarEl.innerHTML = html;
  }

  input.addEventListener('click', function (event) {
    event.stopPropagation();
    calendarEl.hidden = !calendarEl.hidden;
    if (!calendarEl.hidden) render();
  });

  document.addEventListener('click', function (event) {
    if (calendarEl.hidden) return;
    if (!calendarEl.contains(event.target) && event.target !== input) calendarEl.hidden = true;
  });

  calendarEl.addEventListener('click', function (event) {
    var btn = event.target.closest('button');
    if (!btn) return;
    var aktion = btn.dataset.action;

    if (aktion === 'prev') { viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; } render(); return; }
    if (aktion === 'next') { viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; } render(); return; }
    if (aktion === 'reset') { von = null; bis = null; uebernehmen(); render(); return; }
    if (aktion === 'close') { calendarEl.hidden = true; return; }

    if (btn.dataset.date && !btn.disabled) {
      var teile = btn.dataset.date.split('-').map(Number);
      var gewaehlt = new Date(teile[0], teile[1] - 1, teile[2]);
      if (!von || bis) {
        von = gewaehlt; bis = null;
      } else if (gewaehlt < von) {
        von = gewaehlt;
      } else {
        bis = gewaehlt;
      }
      uebernehmen();
      render();
    }
  });
})();

/* -------------------------------------------------------------------
   Hinweis zur kurzfristigen Belieferung

   Der Warenkorb kennt die Lieferadresse noch nicht, deshalb wird die
   Postleitzahl hier abgefragt. Liegt ihr zweistelliger Anfang NICHT in
   der im Theme-Editor gepflegten Liste der Bereiche im Umkreis von
   250 km, erscheint der Hinweis. Die Liste steht im Baustein der
   Warenkorb-Fusszeile und laesst sich ohne Code anpassen.
   ------------------------------------------------------------------- */
(function () {
  var plzFeld = document.getElementById('CartLieferPlz');
  var note = document.getElementById('CartRadiusNote');
  if (!plzFeld || !note) return;

  var nah = (note.dataset.bereiche || '')
    .split(',')
    .map(function (s) { return s.trim(); })
    .filter(function (s) { return s.length === 2; });

  function pruefen() {
    var plz = (plzFeld.value || '').replace(/\D/g, '');
    if (plz.length < 2) { note.hidden = true; return; }
    note.hidden = nah.indexOf(plz.slice(0, 2)) !== -1;
  }

  plzFeld.addEventListener('input', pruefen);
  plzFeld.addEventListener('blur', pruefen);
  pruefen();
})();
